<template>
  <v-sheet class="text-center mb-5" style="font-size: 10px; opacity: 0.5;">
    <p>Информация на период с {{ d_start }} по {{ d_end }}</p>
  </v-sheet>

  {{ info }}


</template>

<script>
import { InfoBlock } from "@/store/wp_planner/info.store";
import moment from "moment";
import { CurrentPeriod } from "@/store/wp_planner/main.store";

export default {
  name: "SpecCard__WP_InfoCard",
  data() {
    return {
      moment: moment,
      date: CurrentPeriod().get()
    }
  },
  methods: {

  },
  computed: {
    current_period() {
      return CurrentPeriod().get()
    },
    d_start() {
      return this.current_period.format('YYYY-MM-DD[T]00:00:00')
    },
    d_end() {
      return moment(this.d_start).endOf('week').format('YYYY-MM-DD[T]23:59:59')
    },
    info: {
      get() {
        return InfoBlock().get()
      },
      set(value) {
        InfoBlock().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
